import "./bootstrap";
import { useGlobalStore } from "@stores/global";
import { createApp } from "vue/dist/vue.esm-bundler";
import { createPinia } from "pinia";
import router from "./router";
import clickOutside from "@directives/clickOutside";

const pinia = createPinia();
const app = createApp({}).use(router).use(pinia);

const global = useGlobalStore();
app.directive("click-outside", clickOutside);

global.setup();

/* Mount App */
app.mount("#wishlisted");
